import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { PageLoaderComponent } from './shared/loading/components/page-loader/page-loader.component';
import { LoadingService } from './shared/loading/loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PageLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly loadingService = inject(LoadingService);

  readonly isLoading = this.loadingService.isLoading;
  readonly loadingMessage = this.loadingService.message;

  // Language, theme and auth initialization are handled by app initializers
}
